
import { PureComponent } from 'react';
import type { Dispatch } from 'redux';

import { createDeepLinkingPageEvent, sendAnalytics } from '../../analytics';
import { connect } from '../../base/redux';
import { openWebApp } from '../actions';

type Props = {

    /**
     * Used to dispatch actions from the buttons.
     */
    dispatch: Dispatch<any>,

};


/**
 * React component representing no mobile app page.
 *
 * @class MobileWeb
 */
class MobileWeb extends PureComponent<Props> {

    /**
     * Initializes a new {@code MobileWeb} instance.
     *
     * @param {Object} props - The read-only React {@code Component} props with
     * which the new instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        // Bind event handlers so they are only bound once per instance.
        this._onLaunchWeb = this._onLaunchWeb.bind(this);
    }


    /**
     * Implements the Component's componentDidMount method.
     *
     * @inheritdoc
     */
    componentDidMount() {
        this._onLaunchWeb();
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return null;
    }

    _onLaunchWeb: () => void;

    /**
     * Handles launch web button clicks.
     *
     * @returns {void}
     */
    _onLaunchWeb() {
        sendAnalytics(
            createDeepLinkingPageEvent(
                'displayed', 'MobileBrowser', { isMobileBrowser: true }));
        this.props.dispatch(openWebApp());
    }

}

export default connect()(MobileWeb);
